/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ slug: NonNullable<unknown> }} Cmspost_Error_Target_Missing1Inputs */

const vi_cmspost_error_target_missing1 = /** @type {(inputs: Cmspost_Error_Target_Missing1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bài viết "${i?.slug}" chưa đăng hoặc không tồn tại — chọn bài khác cho liên kết.`)
};

/**

* @param {Cmspost_Error_Target_Missing1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspost_error_target_missing1 = /** @type {((inputs: Cmspost_Error_Target_Missing1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspost_Error_Target_Missing1Inputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspost_error_target_missing1(inputs)
});
export { cmspost_error_target_missing1 as "cmsPost_error_target_missing" }